<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>车辆报停列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card" >
      <!-- 搜索  新增-->
      <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">
            <el-form-item label="报停日期" size="small" label-width="70px">
              <el-date-picker
                  v-model="searchForm.add_time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车牌号" size="small" label-width="120px">
              <el-input v-model="searchForm.queryParams" style="width: 200px;" placeholder="请输入车牌号" clearable type="text"></el-input>
            </el-form-item>


            <el-form-item>
              <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
            </el-form-item>





      </el-form>

      <!-- 表格 -->
      <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          height="450" :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
      >
<!--        <el-table-column-->
<!--            label="ID"-->
<!--            prop="id"-->
<!--            :show-overflow-tooltip='true'>-->
<!--        </el-table-column>-->
        <el-table-column
            label="车牌"
            width="100px"
            prop="plate_number"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车主"
            prop="username"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="所有人"
            prop="allPerson"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="报停日期"
            prop="end_time"
            width="100px"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            {{ scope.row.bx_end_time | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column
            label="启用日期"
            prop="start_time"
            width="100px"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            {{ scope.row.bx_start_time | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column
            label="备注"
            prop="remark"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="订单信息"
            :show-overflow-tooltip='true' align="center">
<!--          <el-table-column-->
<!--              label="签单日期"-->
<!--              :show-overflow-tooltip='true'>-->
<!--            <template slot-scope="scope">{{ scope.row.effective_date | dateFormat }}</template>-->
<!--          </el-table-column>-->
          <el-table-column
              prop="start_time"
              label="保险起期"
              :show-overflow-tooltip='true'>
            <template slot-scope="scope">{{ scope.row.bx_start_time | dateFormat }}</template>
          </el-table-column>
          <el-table-column
              prop="end_time"
              label="保险止期"
              :show-overflow-tooltip='true'>
            <template slot-scope="scope">{{ scope.row.bx_end_time | dateFormat }}</template>
          </el-table-column>
          <el-table-column
              prop="corp_name"
              label="保险公司"
              :show-overflow-tooltip='true'>
          </el-table-column>
<!--          <el-table-column-->
<!--              prop="product_md_title"-->
<!--              label="险种方案"-->
<!--              :show-overflow-tooltip='true'-->
<!--          >-->
<!--          </el-table-column>-->
          <el-table-column
              prop="product_name"
              label="险种"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="操作" width="210px">
          <template slot-scope="scope">

<!--            <el-button type="danger" size="small" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>-->
            <div>
              <span v-if="scope.row.stop_fileurl">
                <el-button v-if="scope.row" type="warning" size="mini" icon="el-icon-download"  @click="dowfile(scope.row.stop_fileurl)">报停</el-button>
                <el-button v-if="scope.row" type="warning" size="mini" icon="el-icon-document" @click="goDoc(scope.row.stop_fileurl)">报停</el-button>
            </span>
              <span v-else>
              报停批单暂无
            </span>
            </div>
            <div>
              <span v-if="scope.row.go_fileurl">
                  <el-button v-if="scope.row" type="success" size="mini" icon="el-icon-download"  @click="dowfile(scope.row.go_fileurl)">复驶</el-button>
                  <el-button v-if="scope.row" type="success" size="mini" icon="el-icon-document" @click="goDoc(scope.row.go_fileurl)">复驶</el-button>
            </span>
              <span v-else>
              复驶批单暂无
            </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 50,100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="档案编号"  size="small">
              <el-input v-model="form.file_no" autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="挂靠单位"  size="small">
              <el-input v-model="form.unit" autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="报停日期"  size="small">
              <el-date-picker v-model="form.end_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用日期"  size="small">
              <el-date-picker v-model="form.start_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <!--车辆-->
            <carListTemp ref="carListTemp" @changeData="setcarInfo"></carListTemp>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属人" prop="allPerson" size="small">
              <el-input v-model="form.allPerson" autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="收费金额" prop="fee" size="small">
              <el-input v-model="form.fee" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark" size="small">
              <el-input v-model="form.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <!--
          <el-col :span="12">
            <shopCompanyTemp ref="shopCompanyTemp"></shopCompanyTemp>
          </el-col>-->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import eTable from "../common/eTable.vue";
  import moment from 'moment'     //日期时间转换
  import carListTemp from "../common/carlistTemp.vue";
  export default {
    name: "shipCompany",
    components: {
      eTable,
      carListTemp
    },
    props: {},
    data() {
      return {
        // 搜索
        searchForm: {
          queryParams:'',
          start_time:'',
          end_time:'',
          add_time:''
        },
        searchRules: {
        },
        // 数据
        tableLoadData: [],
        limit: 10,
        page:1,// 当前页码
        total:0,//总条目数
        id: '',
        rules: {
          allPerson:[{ required: true, message: "请输入所属人", trigger: "blur" }],
          remark:[{ required: true, message: "请输入备注", trigger: "blur" }],
          fee:[{required: true, message: '请输入费用', trigger: 'blur' },
            {pattern:'([1-9]\\d*(\\.\\d*[1-9])?)|(0\\.\\d*[1-9])',message: '费用必须大于0',trigger: 'blur'}
          ],
        },
        dialogFormVisible: false,
        title: '',
        form: {
          end_time:'', //报停日期
          start_time:'', //启用日期
          file_no:'',//档案编号
          unit:'',//挂靠单位
          car_id:'', // 车辆id
          shop_id:'', //运输公司id
          allPerson:'', //所属人
          fee:'', //收费金额
          remark:'', //备注
        },
        uploadImg: '',
        uploadDialog: false
      };
    },
    created() {
      this.DataList()
    },
    mounted() {},
    filters: {
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD");
      },

    },
    methods: {
      setcarInfo(value){
        this.$set(this.form,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
        //this.form.vin = value.vin
        //this.form.model = value.model
        // this.form.issue_date = value.issue_date
        // this.form.register_date = value.register_date
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.page,
          pageSize:this.limit
        }
        if(this.searchForm.queryParams) param.queryParams = this.searchForm.queryParams
        if(this.searchForm.add_time){
          const formattedStartTime = this.getTime(this.searchForm.add_time[0]);
          const formattedEndTime = this.getTime(this.searchForm.add_time[1]);
          param.start_time = formattedStartTime;
          param.end_time = formattedEndTime;
        }
        this.$axios.getAlarmStop(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        this.DataList()
      },
      getTime (time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        return y + '-' + m + '-' + d
      },
      // 新增
      addData() {
        this.title = '新增'
        this.form = {
          // role_name: '',
        }
        this.dialogFormVisible = true
      },
      handelEdit(index,row) {
        this.id = index.id

        this.title = '编辑'
        this.form = {
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
              const param = {
                end_time:this.form.end_time, //报停日期
                start_time:this.form.start_time, //启用日期
                car_id: this.$refs.carListTemp.form.car_id,//this.form.car_id,
                //shop_id: this.$refs.shopCompanyTemp.form.shop_id,//this.form.shop_id,
                allPerson: this.form.allPerson,
                fee:this.form.fee,
                remark: this.form.remark,
                file_no:this.form.file_no,
                unit:this.form.unit,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              if(this.id) param.id = this.id
              this.$axios.saveAlarmStop(param).then(res =>{
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
          }
        })
      },
      searchSubmit() {
        this.page = 1
        this.DataList()
      },

      handelDel(e) {
        this.$confirm('此操作将删除该报停信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          //console.log(param);
          this.$axios.delAlarmStop(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      dowfile(stop_fileurl){
        if(stop_fileurl){
          window.open(stop_fileurl)
        }else{
          this.$message.error('没有文件')
        }

      },

      goDoc(row){

        if(row){
          return new Promise((resolve, reject) => {
            let blob = null;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", row);
            xhr.responseType = "blob";
            xhr.onload = () => {
              blob = xhr.response;
              const blobob = new Blob([blob], { type: 'application/pdf;charset=utf-8' });
              const href = window.URL.createObjectURL(blobob);
              window.open(href, 'newWindow');
              resolve(file);
            };
            xhr.onerror = (e) => {
              reject(e)
            };
            xhr.send();
          });
        }else{
          this.$message.error('没有文件')
        }
      },
    },
  };
</script>
<style>
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/car/suspendList.vue